import React, { useState } from 'react';

import ClearIcon from '@mui/icons-material/Clear';
import {
  Box,
  Button,
  FormGroup,
  Grid,
  InputAdornment,
  Stack,
  Switch,
  TextField,
  Typography,
} from '@mui/material';

import { useIntelState } from '../../context/IntelState';
import RestUtilities from '../../services/RestUtilities';
import KdNewsReport from '../KingdomNews/KdNewsReport';
import ProvinceNewsReport from '../KingdomNews/ProvinceNewsReport';

const buttonStyles = { height: '30px' };

const Formatter = () => {
  const { intelState, intelDispatch } = useIntelState();
  const [parseString, setParseString] = useState<string>('');
  const [isProv, setIsProv] = useState(false);
  const kdNews = intelState.kingdomNews;
  const provNews = intelState.provinceNews;

  const handleParseKdNews = (append: boolean) => {
    const postData = async () => {
      let newsToParse;
      if (append && kdNews) {
        newsToParse = `${kdNews.parseString}\n${parseString}`;
      } else {
        newsToParse = parseString;
      }
      const response = await RestUtilities.post(`News/v1/kdnews`, {
        parseString: newsToParse,
      });
      if (response.ok) {
        intelDispatch({
          type: 'SET_KINGDOM_NEWS',
          payload: { ...response.content, parseString: newsToParse },
        });
      }
    };
    if (parseString) {
      postData();
    }
  };

  const handleParseProvNews = (append: boolean) => {
    const postData = async () => {
      let newsToParse;
      if (append && provNews) {
        newsToParse = `${provNews.parseString}\n${parseString}`;
      } else {
        newsToParse = parseString;
      }
      const response = await RestUtilities.post(`News/v1/provinceNews`, {
        parseString: newsToParse,
      });
      if (response.ok) {
        intelDispatch({
          type: 'SET_PROVINCE_NEWS',
          payload: { ...response.content, parseString: newsToParse },
        });
      }
    };
    if (parseString) {
      postData();
    }
  };

  return (
    <Box
      className='Kingdom News'
      sx={{
        mt: 2,
        mx: 2
      }}>
      <Typography variant='h2' gutterBottom component='div'>
        Parse News
      </Typography>
      <Grid
        container
        justifyContent='flex-start'
        direction='row'
        alignItems='center'
        spacing={2}
        mt={1}
        mb={3}
      >
        <Grid
          size={{
            xs: 12,
            sm: 6,
            md: 4
          }}>
          <TextField
            id='war-plan-title'
            placeholder='Paste your news items here'
            label='News text'
            value={parseString}
            onChange={(e) => setParseString(e.currentTarget.value)}
            fullWidth
            multiline
            maxRows={2}
            variant='outlined'
            autoFocus
            InputProps={{
              endAdornment: (
                <InputAdornment position='start'>
                  {parseString && (
                    <ClearIcon onClick={(e) => setParseString('')} />
                  )}
                </InputAdornment>
              ),
            }}
          />
        </Grid>
        {(kdNews && !isProv) || (provNews && isProv) ? (
          <>
            <Grid>
              <Button
                variant='outlined'
                onClick={() =>
                  isProv ? handleParseProvNews(true) : handleParseKdNews(true)
                }
                sx={buttonStyles}
                size='small'
              >
                Add new items
              </Button>
            </Grid>
            <Grid>
              <Button
                variant='outlined'
                onClick={() => {
                  const type = isProv
                    ? 'SET_PROVINCE_NEWS'
                    : 'SET_KINGDOM_NEWS';
                  intelDispatch({
                    type: type,
                    payload: undefined,
                  });
                }}
                sx={buttonStyles}
                size='small'
              >
                Delete Report
              </Button>
            </Grid>
          </>
        ) : (
          <Grid>
            <Button
              variant='outlined'
              onClick={() =>
                isProv ? handleParseProvNews(false) : handleParseKdNews(false)
              }
              sx={buttonStyles}
              size='small'
            >
              Create New
            </Button>
          </Grid>
        )}
        <Grid>
          <FormGroup>
            <Stack direction='row' spacing={1} alignItems='center'>
              <Typography variant='body2'>KD</Typography>
              <Switch
                name='kdProvNewsSwitch'
                checked={isProv}
                onChange={() => setIsProv(!isProv)}
                size='small'
              />
              <Typography variant='body2'>Province</Typography>
            </Stack>
          </FormGroup>
        </Grid>
      </Grid>
      {kdNews && !isProv && <KdNewsReport />}
      {provNews && isProv && <ProvinceNewsReport />}
    </Box>
  );
};

export default Formatter;
